// hooks/useDisableCopy.js
import { useEffect } from 'react';

const useDisableCopy = () => {
  useEffect(() => {
    // Disable copy
    const disableCopy = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable context menu (right-click)
    const disableContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable cut
    const disableCut = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable paste
    const disablePaste = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable keyboard shortcuts
    const disableKeyboardShortcuts = (e) => {
      // Disable Ctrl+C, Ctrl+X, Ctrl+V, Ctrl+U, Ctrl+S
      if (e.ctrlKey || e.metaKey) {
        const disabledKeys = ['c', 'C', 'x', 'X', 'v', 'V', 'u', 'U', 's', 'S'];
        if (disabledKeys.includes(e.key)) {
          e.preventDefault();
          return false;
        }
      }
      
      // Disable F12
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }
      
      // Disable Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C
      if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i' || e.key === 'J' || e.key === 'j' || e.key === 'C' || e.key === 'c')) {
        e.preventDefault();
        return false;
      }
    };

    // Apply CSS to disable selection
    document.body.style.userSelect = 'none';
    document.body.style.webkitUserSelect = 'none';
    document.body.style.mozUserSelect = 'none';
    document.body.style.msUserSelect = 'none';

    // Add event listeners
    document.addEventListener('copy', disableCopy);
    document.addEventListener('cut', disableCut);
    document.addEventListener('paste', disablePaste);
    document.addEventListener('contextmenu', disableContextMenu);
    document.addEventListener('keydown', disableKeyboardShortcuts);

    return () => {
      // Remove event listeners
      document.removeEventListener('copy', disableCopy);
      document.removeEventListener('cut', disableCut);
      document.removeEventListener('paste', disablePaste);
      document.removeEventListener('contextmenu', disableContextMenu);
      document.removeEventListener('keydown', disableKeyboardShortcuts);
      
      // Reset CSS
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';
      document.body.style.mozUserSelect = '';
      document.body.style.msUserSelect = '';
    };
  }, []);
};

export default useDisableCopy;